import { gql, useQuery } from "@apollo/client";
import React, { useState } from "react";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { Loading } from "../../../../components/Loading";
import { Link } from "react-router-dom";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "applications", to: "#" },
  { text: "products", to: "#" },
  { text: "choice", to: "/product/choice/list" },
];

const QUERY = gql`
  query listProductChoice(
    $status: LoginlessOrderStatus
    $offset: Int = 0
    $limit: Int = 10
  ) {
    listProductChoice(status: $status, offset: $offset, limit: $limit) {
      id
      product {
        id
        picture
        code
      }
      status
      inputDate
      supplier
      approvedBy
      rejectdBy
      approvedDate
      rejectedDate
    }
  }
`;

export function ProductChoiceScreen() {
  const [index, setIndex] = useState(0);
  const [status, setStatus] = useState<"PENDING" | "APPROVED" | "REJECTED">(
    "PENDING"
  );

  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    variables: {
      offset: 0,
      limit: 10000,
      status,
    },
  });

  const onChangeIndex = (e: number) => {
    setIndex(e);
    switch (e) {
      case 0:
        setStatus("PENDING");
        break;
      case 1:
        setStatus("APPROVED");
        break;
      case 2:
        setStatus("REJECTED");
        break;
      default:
        setStatus("PENDING");
        break;
    }
  };

  if (data === undefined || loading) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-6">
            <h5 className="mb-4">Product Choice</h5>
            <TabInlineSmaller index={index} onChangeIndex={onChangeIndex} />
            <Loading />
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-6">
          <h5 className="mb-4">Product Choice</h5>
          <TabInlineSmaller index={index} onChangeIndex={onChangeIndex} />
          {data.listProductChoice.length > 0 ? (
            <table className="mt-4 table table-padded">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Code</th>
                  <th>Date Log</th>
                </tr>
              </thead>
              <tbody>
                {data.listProductChoice.map((item: any) => {
                  return (
                    <tr key={item.id}>
                      <td>
                        <img
                          src={item.product.picture}
                          alt=""
                          style={{
                            width: 65,
                            height: 65,
                            borderRadius: 4,
                            objectFit: "cover",
                          }}
                        />
                      </td>
                      <td>
                        <a
                          href={
                            "https://www.l192.com/product/" + item.product.id
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          L192: {item.product.code}
                        </a>
                      </td>
                      <td>
                        <span>Request Date: {item.inputDate}</span>
                        {item.approvedDate && (
                          <>
                            <br />
                            <span>Approve Date: {item.approvedDate}</span>
                          </>
                        )}
                        {item.rejectedDate && (
                          <>
                            <br />
                            <span>Reject Date: {item.rejectedDate}</span>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <span className="mt-4">No List</span>
          )}
        </div>
      </div>
    </Content>
  );
}

function TabInlineSmaller({
  index,
  onChangeIndex,
}: {
  index: number;
  onChangeIndex: (e: number) => void;
}) {
  const onClickLink = (e: number) => {
    onChangeIndex(e);
  };

  return (
    <ul className="nav nav-tabs smaller">
      <li className="nav-item">
        <Link
          to="#"
          className={`nav-link ${index === 0 ? "active" : ""}`}
          onClick={() => onClickLink(0)}
        >
          Pending
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to="#"
          className={`nav-link ${index === 1 ? "active" : ""}`}
          onClick={() => onClickLink(1)}
        >
          Approved
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to="#"
          className={`nav-link ${index === 2 ? "active" : ""}`}
          onClick={() => onClickLink(2)}
        >
          Rejected
        </Link>
      </li>
    </ul>
  );
}
